import { intl, type LocaleId } from '@frameio/i18n';
import { SUPPORT_URL } from '../constants';

type SupportArticleLocale = Exclude<LocaleId, 'zz-ZZ'>;

const LOCALE_TO_PATH_MAP = {
  'en-US': 'en',
  'ja-JP': 'ja',
  'zh-CN': 'zh-CN',
  'de-DE': 'de',
  'es-ES': 'es',
  'fr-FR': 'fr',
  'it-IT': 'it',
  'ko-KR': 'ko',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru',
} as const satisfies Record<SupportArticleLocale, string>;

type SupportArticlePath = (typeof LOCALE_TO_PATH_MAP)[SupportArticleLocale];

const DEFAULT_LOCALE_PATH: SupportArticlePath = LOCALE_TO_PATH_MAP['en-US'];

export const getSupportArticleUrl = (
  path: string,
  locale = intl().locale
): string => {
  const localePath: SupportArticlePath =
    locale in LOCALE_TO_PATH_MAP
      ? LOCALE_TO_PATH_MAP[locale as SupportArticleLocale]
      : DEFAULT_LOCALE_PATH;
  return `${SUPPORT_URL}/${localePath}/articles/${path}`;
};
